import { Button, Container, Nav, Navbar, NavDropdown,Offcanvas } from 'react-bootstrap'
// import { host } from '../axiosInterceptor' 
import Profile from './Profile';

import { useNavigate  } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { get_user,auth_delete } from '../module/auth'

const host = process.env.REACT_APP_URL_APP;

export default function NavbarMain() {

  const navigate = useNavigate();

  const [user, set_user] = useState(undefined)

  const hanbled_click = () => navigate("/register")

  const hanbled_register = () => navigate("/login")

  // const hanbled_home = () => navigate("/")
  
  useEffect(()=>{
    
    const userData = get_user();
    if(userData) set_user(userData);

  },[]);


  const on_logout = ()=>{ auth_delete(); set_user({}); window.location.href="/"; }
  
  return (
    <Navbar collapseOnSelect fixed="top" expand="md" className="bg-body-tertiary p-0">
      <Container fluid className='' style={{backgroundColor:"#336799"}}>
        
          <Navbar.Brand href="/" className='p-0'>
            <img id='img_logo' style={{width:"100%"}} src={`${host}//bannerCedij2020II2.png`} alt="" />
        
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarScroll" style={{position:"absolute",right:"10px",backgroundColor:"#336799"}}/>
       
        <Navbar.Offcanvas id="navbarScroll">

          <Offcanvas.Header>
            Menú Principal
          </Offcanvas.Header>

          <Offcanvas.Body>

          <Nav className="me-auto" navbarScroll >
              {/* <Nav.Link className='w-auto' href="#action1">Nosotros</Nav.Link>
              <NavDropdown title="Nuestros Servicios" id="navbarScrollingDropdown">
                <NavDropdown.Item href="/search" style={{"color":"#c18f55"}}>Buscardor Jurídico Documental</NavDropdown.Item>
                <NavDropdown.Item href="/history-sentences">Sentencias Históricas</NavDropdown.Item>
                <NavDropdown.Item href="/digital-publications/Boletines-Judiciales/1">Publicaciones Digitales</NavDropdown.Item>
              </NavDropdown> */}
            </Nav>

          <div className='w-auto' hidden={user === undefined}>
            <Nav className="me-auto" navbarScroll>

              <NavDropdown className='text-white' title={user !== undefined ? user.fullName: ""} align="end">

                <Profile user = {user} logout={on_logout}/>

              </NavDropdown >
            </Nav>
            
          </div>

          <div className='w-auto' hidden={user !== undefined} style={{ minWidth:"240px" }}>

            <div style={{marginRight:"auto",marginLeft:"auto",display:"table"}}>
              <Button variant="light m-1" onClick={hanbled_register}>Iniciar Sesión</Button>
              <Button variant="light m-1" onClick={hanbled_click}>Registrese</Button>
            </div>

          </div> 
          </Offcanvas.Body>
           
        </Navbar.Offcanvas>

      </Container>     
    </Navbar>
  )
}
